import Bill from './modules/BillApi'
import Cash from './modules/CashApi'
import Check from './modules/CheckApi'
import Client from './modules/ClientApi'
import ClientCredit from './modules/ClientCreditApi'
import Deposit from './modules/DepositApi'
import Devolution from './modules/DevolutionApi'
import Envelope from './modules/EnvelopeApi'
import Exchange from './modules/ExchangeApi'
import FinancialResume from './modules/FinancialResume'
import InternalPayment from './modules/InternalPaymentApi'
import PayedShipping from './modules/PayedShippingApi'
import Payment from './modules/PaymentApi'
import PayTrace from './modules/PayTraceApi'
import ReturnedCheck from './modules/ReturnedCheckApi'
import Reversal from './modules/ReversalApi'
import PayDevolution from './modules/PayDevolutionApi'
import VrtTransaction from './modules/VrtTransactionApi'
import Pix from './modules/PixApi'
import InternalPaymentApi from './modules/InternalPayment'
import RetailPayDrivers from './modules/RetailPayDrivers'
import Shipping from './modules/ShippingApi'
import IncomeExtract from './modules/IncomeExtract'
import AssignedVrtPayment from './modules/AssignedVrtPaymentApi'
import FiscalNote from './modules/FiscalNoteApi'
import VrtProtest from './modules/VrtProtestApi'
import FinancialConsolidatedReport from "./modules/FinancialConsolidatedReportApi"
import SellerComissionConfig from './modules/SellerComissionConfigApi'

export default {
  Bill,
  Cash,
  Check,
  Client,
  ClientCredit,
  Deposit,
  Devolution,
  Envelope,
  Exchange,
  FinancialResume,
  InternalPayment,
  PayedShipping,
  Payment,
  PayTrace,
  PayDevolution,
  ReturnedCheck,
  Reversal,
  VrtTransaction,
  Pix,
  InternalPaymentApi,
  RetailPayDrivers,
  Shipping,
  IncomeExtract,
  AssignedVrtPayment,
  FiscalNote,
  VrtProtest,
  FinancialConsolidatedReport,
  SellerComissionConfig,
}
